import {defineCustomElement} from 'extensions/utils';
import stylesheet from './x-search-facet-value.component.scss?as=stylesheet';
import {html, nothing, LitElement} from 'lit';

export class FacetValue extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			color: {
				type: String
			},
			count: {
				type: Number
			},
			end: {
				type: Number
			},
			facet: {
				type: String
			},
			image: {
				type: String
			},
			label: {
				type: String
			},
			max: {
				type: Number
			},
			min: {
				type: Number
			},
			rangeType: {
				attribute: 'range-type',
				type: String
			},
			selected: {
				type: Boolean
			},
			showInputs: {
				attribute: 'show-inputs',
				type: Boolean
			},
			start: {
				type: Number
			},
			type: {
				type: String
			},
			value: {
				type: String
			}
		};
	}

	constructor () {
		super();

		this.color = '';
		this.count = 0;
		this.end = 0;
		this.facet = '';
		this.image = '';
		this.label = '';
		this.max = 0;
		this.min = 0;
		this.rangeType = '';
		this.selected = false;
		this.showInputs = false;
		this.start = 0;
		this.type = '';
		this.value = '';
	}

	handleChange (e) {
		this.value = e.target?.value || this.value;
		this.dispatchEvent(new CustomEvent('change'));
	}

	renderCheckbox () {
		return html`<x-checkbox
			?selected="${this.selected}"
			?hide-checkbox="${this.type !== 'checkbox'}"
			@change="${this.handleChange}"
			count="${this.count}"
			label="${this.label}"
		>
		</x-checkbox>`;
	}

	renderColor () {
		return html`<x-swatch
			?checked="${this.selected}"
			@change="${this.handleChange}"
			color="${this.color}"
			image="${this.image}"
			label="${this.label}"
		></x-swatch>`;
	}

	renderRangeSlider () {
		return html`<x-range-slider @change="${this.handleChange}" facet="${this.facet}" label="${this.label}" start="${this.start}" end="${this.end}" min="${this.min}" max="${this.max}" range-type="${this.rangeType}" ?show-inputs="${this.showInputs}"></x-range-slider>`;
	}

	renderOpenRange () {
		return nothing;
	}

	render () {
		switch (this.type) {
			default:
			case 'link':
			case 'size':
			case 'unsupported':
			case 'checkbox': {
				return this.renderCheckbox();
			}
			case 'color': {
				return this.renderColor();
			}
			case 'date-range':
			case 'numeric-range':
			case 'openrange': {
				return this.renderOpenRange();
			}
			case 'range-slider': {
				return this.renderRangeSlider();
			}
		}
	}
};

defineCustomElement('x-search-facet-value', FacetValue);
